import {
    NavBar,
    Field,
    DropdownMenu,
    DropdownItem,
    List
} from 'vant';
import 'vant/lib/index.css';
import Vue from "vue";

Vue.use(NavBar);
Vue.use(Field);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(List);